import { Store, createEvent } from 'effector'

import * as account from './account/account'
import * as auth from './auth/auth'
import * as filters from './filters/filters'
import * as localisation from './localisation/localisation'

const persisted: Store<any>[] = [account.store, auth.store, filters.store, localisation.store]

export const persist = (): Promise<void> => {
  const VERSION = '1.0.2.3'
  const VERSION_KEY = 'persist:version'

  return new Promise((res, rej) => {
    if (!localStorage) {
      return rej()
    }

    const version = localStorage.getItem(VERSION_KEY)
    const reload = version === VERSION

    if (!version || !reload) {
      localStorage.setItem(VERSION_KEY, VERSION)
    }

    const rehydrate = createEvent('REHYDRATE')

    const persistStore = <State>(store: Store<State>): Promise<void> => {
      const name = store.shortName
      const persistKey = `persist:${name}`

      if (reload) {
        const snapshot = localStorage.getItem(persistKey)

        if (snapshot) {
          store.on(rehydrate, () => JSON.parse(snapshot))
          rehydrate()
        }
      }

      store.watch((state) => {
        localStorage.setItem(persistKey, JSON.stringify(state))
      })

      return Promise.resolve()
    }

    return Promise.all(persisted.map(persistStore)).then(() => res())
  })
}

export const reset = () => {
  // add reset from store
  account.actions.reset()
  auth.actions.reset()
  filters.actions.reset()
  localisation.actions.reset()
}
